import { memo } from 'react';
import clsx from 'clsx';

import MainNavigation from './components/main-navigation/main-navigation';

import styles from './styles/header.module.css';

export default memo(Header);

function Header() {
	return (
		<header className={clsx(styles['header'])}>
			<MainNavigation />
		</header>
	);
}
